export const EXCMDEVICEMODEL_CREATE_RESET = 'EXCMDEVICEMODEL_CREATE_RESET'
export const EXCMDEVICEMODEL_CREATE_SET_CREATED = 'EXCMDEVICEMODEL_CREATE_SET_CREATED'
export const EXCMDEVICEMODEL_CREATE_SET_ERROR = 'EXCMDEVICEMODEL_CREATE_SET_ERROR'
export const EXCMDEVICEMODEL_CREATE_SET_VIOLATIONS = 'EXCMDEVICEMODEL_CREATE_SET_VIOLATIONS'
export const EXCMDEVICEMODEL_CREATE_TOGGLE_LOADING = 'EXCMDEVICEMODEL_CREATE_TOGGLE_LOADING'
